import React from 'react';
import { getAgeWithUnit } from '../../../utils/dateTimeUtil';
import { PropTypes } from 'prop-types';
export default function Age(props) {
    const ageWithUnit = getAgeWithUnit(props?.dob);
    if (ageWithUnit) {
        return (
            <div>
                <span>{ageWithUnit.age}</span> {ageWithUnit.unit}
            </div>
        );
    } else {
        return null;
    }
}
Age.propTypes = {
    dob: PropTypes.string
};
